<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["which_car"] }}</p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["select_to_request"] }}
      </p>
      <div
        class="car"
        v-for="item in parkedVehicles"
        :key="item.id"
        v-on:click="next(item)"
      >
        <div class="model">
          <button class="button">
            {{ item.make || "" }} {{ item.model || "" }} {{ item.year || "" }}
          </button>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!loading"></div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    } else {
      this.parkedVehicles = this.$store.getters.PARKED_VEHICLES;
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      requestType: "PARKENDA",
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      parkedVehicles: [],
      next: (item) => {
        item.flagIsRequested = item.flagIsRequested === 0 ? false : true;
        this.$store.dispatch("SAVE_REQUESTED_VEHICLE", item);
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(
            `${process.env.SERVER_URL}/F1366CBBBAB44CACB2197655F39F191F/${this.$store.getters.USER.barcode}/${this.requestType}`,
            {
              vehicle: item
            },
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Request car response:");
            console.log(response);

            if (response && response.data && response.data.status) {
              switch (response.data.status) {
                case 0:
                  {
                    this.$modal.show("dialog", {
                      text: this.$store.getters.TRANSLATIONS[
                        "vehicle_request_has_failed"
                      ],
                      buttons: [
                        {
                          title: "OK",
                          handler: () => {
                            this.$router.push("/login");
                          }
                        }
                      ]
                    });
                  }
                  break;
                case 1:
                  {
                    this.$modal.show("dialog", {
                      text: this.$store.getters.TRANSLATIONS[
                        "vehicle_has_been_requested"
                      ],
                      buttons: [
                        {
                          title: "OK",
                          handler: () => {
                            this.$router.push("/requestInProgress");
                          }
                        }
                      ]
                    });
                  }
                  break;
                case 2:
                  {
                    // this.$modal.show("dialog", {
                    //   text: this.$store.getters.TRANSLATIONS[
                    //     "this_car_is_already"
                    //   ],
                    //   buttons: [
                    //     {
                    //       title: "OK",
                    //       handler: () => {
                    //         this.$router.push("/requestInProgress");
                    //       }
                    //     }
                    //   ]
                    // });
                    this.$router.push("/requestInProgress");
                  }
                  break;
                case 3:
                  {
                    this.$store.dispatch(
                      "SAVE_PARKED_VEHICLES",
                      response.data.vehicles
                    );
                  }
                  break;
                case 4:
                  {
                    this.$store.dispatch(
                      "SAVE_DROP_OFFS",
                      response.data.dropOffs
                    );
                    this.$router.push("/selectDropOff");
                  }
                  break;
              }
            } else {
              console.log("Request car failed:");
              console.log(response.data);
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["request_car_failed"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              text = error.response.data.message;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$storage.remove("parkendaToken");
                    this.$router.push("/login");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      back: () => {
        this.$router.go(-1);
      },
      icon: require("@/assets/icon_back.png"),
      nextIcon: require("@/assets/nextArrowIos.jpg")
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.button {
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCar/SelectCar.vue